import React from "react";
import { Building, Home, MapPin } from "lucide-react";
import { ABOUT_IMAGE } from "../mock";

const facts = [
  { icon: Building, title: "برجان", sub: "بتصميم عمراني متكامل" },
  { icon: Home, title: "526", sub: "وحدة سكنية" },
  { icon: MapPin, title: "قرب الحرم", sub: "موقع يخدم الزوار والسكان" },
];

const About = () => {
  return (
    <section id="about" className="py-24 bg-[#F3ECE0]">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 grid lg:grid-cols-2 gap-14 items-center">
        {/* text */}
        <div>
          <span className="text-[#BF9A5A] text-sm font-700">لمحة عن المشروع</span>
          <h2 className="font-display text-3xl lg:text-5xl font-700 text-[#241C15] mt-3 leading-snug">
            برجان في زاوية محورية داخل وجهة مسار
          </h2>
          <p className="text-stone-600 leading-loose mt-6 text-lg">
            يأتي مشروع «مسار كورنر» في موقع استراتيجي مميز داخل وجهة مسار، بتصميم
            يتلاءم مع قدسية المكان والطابع الحضري لمكة المكرمة.
          </p>
          <p className="text-stone-600 leading-loose mt-4">
            يضم كل برج وحدات سكنية متكاملة التشطيبات، خيار مثالي للزوار وحلٌّ شامل
            لمن يبحث عن موقع مميز وخدمات متكاملة قرب الحرم المكي.
          </p>

          <div className="grid grid-cols-3 gap-4 mt-10">
            {facts.map((f, i) => (
              <div key={i} className="bg-white rounded-2xl p-5 shadow-sm border border-stone-200/60 text-center">
                <f.icon className="mx-auto text-[#BF9A5A]" size={26} />
                <div className="font-800 text-[#241C15] mt-3">{f.title}</div>
                <div className="text-xs text-stone-500 mt-1 leading-relaxed">{f.sub}</div>
              </div>
            ))}
          </div>
        </div>

        {/* image */}
        <div className="relative">
          <div className="rounded-3xl overflow-hidden shadow-2xl">
            <img src={ABOUT_IMAGE} alt="تصميم المشروع" className="w-full h-[480px] object-cover" />
          </div>
          <div className="absolute -bottom-6 -right-4 bg-[#BF9A5A] text-white rounded-2xl px-6 py-4 shadow-xl hidden sm:block">
            <div className="text-2xl font-800">2,000م</div>
            <div className="text-xs opacity-90">عن الحرم المكي</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
